import { useEffect, useState } from "react";
import api from "../utils/axios";

interface SettingsData {
  aff_amount: string;
  invitee_amount: string;
  telegram_link: string;
  whatsapp_no: string;
}

const Settings = () => {
  const [settings, setSettings] = useState<SettingsData>({
    aff_amount: "",
    invitee_amount: "",
    telegram_link: "",
    whatsapp_no: "",
  });

  const [loading, setLoading] = useState(false);

  /* ================= FETCH SETTINGS ================= */
  const fetchSettings = async () => {
    try {
      const res = await api.get("/getPaymentSetting");
      setSettings({
        aff_amount: res.data?.aff_amount || "",
        invitee_amount: res.data?.invitee_amount || "",
        telegram_link: res.data?.telegram_link || "",
        whatsapp_no: res.data?.whatsapp_no || "",
      });
    } catch (err) {
      console.error("Failed to load settings", err);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSettings((prev) => ({ ...prev, [name]: value }));
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post("/updatePaymentSetting", settings);
      alert("Settings updated successfully");
      fetchSettings();
    } catch (err) {
      console.error("Update failed", err);
      alert("Failed to update settings");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-8 ">
      {/* ================= PAGE TITLE ================= */}
      <div>
        <h1 className="text-2xl font-bold text-gray-800">
          Settings
        </h1>
        <p className="text-sm text-gray-500">
          Manage affiliate commissions and support details
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-8">
        {/* ================= AFFILIATE SETTINGS ================= */}
        <div className="bg-white border rounded-2xl p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Affiliate Commission
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-sm text-gray-500">
                Affiliate Commission Amount
              </label>
              <input
                type="text"
                name="aff_amount"
                value={settings.aff_amount}
                onChange={handleChange}
                className="w-full border rounded-lg px-3 py-2 mt-1"
                placeholder="e.g. 10"
              />
            </div>

            <div>
              <label className="text-sm text-gray-500">
                Signup Bonus Amount
              </label>
              <input
                type="text"
                name="invitee_amount"
                value={settings.invitee_amount}
                onChange={handleChange}
                className="w-full border rounded-lg px-3 py-2 mt-1"
                placeholder="e.g. 5"
              />
            </div>
          </div>
        </div>

        {/* ================= SUPPORT SETTINGS ================= */}
        <div className="bg-white border rounded-2xl p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Support & Contact
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-sm text-gray-500">
                Telegram Support Link
              </label>
              <input
                type="text"
                name="telegram_link"
                value={settings.telegram_link}
                onChange={handleChange}
                className="w-full border rounded-lg px-3 py-2 mt-1"
                placeholder="https://t.me/yourchannel"
              />
            </div>

            <div>
              <label className="text-sm text-gray-500">
                WhatsApp Number
              </label>
              <input
                type="text"
                name="whatsapp_no"
                value={settings.whatsapp_no}
                onChange={handleChange}
                className="w-full border rounded-lg px-3 py-2 mt-1"
                placeholder="+91XXXXXXXXXX"
              />
            </div>
          </div>
        </div>

        {/* ================= SAVE BUTTON ================= */}
        <div className="flex justify-end">
          <button
            type="submit"
            disabled={loading}
            className="px-6 py-2 rounded-lg bg-gray-900 text-white hover:bg-gray-800 disabled:opacity-50"
          >
            {loading ? "Saving..." : "Save Settings"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Settings;
